import { render, staticRenderFns } from "./IconLeftBottom3.vue?vue&type=template&id=6dc728b2&"
import script from "./IconLeftBottom3.vue?vue&type=script&lang=js&"
export * from "./IconLeftBottom3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dc728b2')) {
      api.createRecord('6dc728b2', component.options)
    } else {
      api.reload('6dc728b2', component.options)
    }
    module.hot.accept("./IconLeftBottom3.vue?vue&type=template&id=6dc728b2&", function () {
      api.rerender('6dc728b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/PopupButtonPositions/IconLeftBottom3.vue"
export default component.exports